export default "https://cdn-static.gokick.com/assets/ea2c661fec3366c14365f7d1c68d2a3d0c715dc9/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";